import { Pipe, PipeTransform } from '@angular/core';
import { TransactionLine } from '../../businesses/models/statements.models';

@Pipe({
  standalone: false,
  name: 'transactionTotal',
  pure: false,
})
export class TransactionTotalPipe implements PipeTransform {
  transform(lines: TransactionLine[], type: 'amount' | 'markup' | 'total' | 'all' = 'all'): string {
    if (type === 'amount') {
      return lines.reduce((acc, line) => acc + (line.amount || 0), 0).toFixed(2);
    }

    if (type === 'markup') {
      return lines.reduce((acc, line) => acc + (line.markup || 0), 0).toFixed(2);
    }

    // Total is included sometimes when the calculation must be done on the server side (recurring transaction instances)
    if (type === 'total') {
      return lines.reduce((acc, line) => acc + (line.total || 0), 0).toFixed(2);
    }

    return lines
      .reduce((acc, line) => {
        return acc + (line.amount || 0) + (line.markup || 0);
      }, 0)
      .toFixed(2);
  }
}
